import { gql } from '@apollo/client';
import { getCartQueryString, getShortTextLabelsQueryString } from './utils';

export const getTripsOerviewCollection = gql`
	query getVignettesOrderManagementCollection($lang: String) {
		vignettesOrderManagementCollection(locale: $lang, limit: 1) {
			items {
				${getCartQueryString()}
				${getShortTextLabelsQueryString([
					'backToOverview',
					'untilRevoked',
					'tripsOverview',
					'noTripsFound',
					'newest',
					'oldest',
					'orderedTrips',
				])}
			}
		}
	}
`;
